/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description OK
 */
export const postApiMacroprojects200Schema = z.any();

export const postApiMacroprojectsMutationRequestSchema = z.object({
  name: z.coerce.string().min(1).max(500),
  client: z.object({
    value: z.coerce.number().int(),
    label: z.coerce.string(),
  }),
  isVisible: z.boolean(),
  costCenter: z
    .object({
      value: z.coerce.number().int(),
      label: z.coerce.string(),
    })
    .nullable(),
});

export const postApiMacroprojectsMutationResponseSchema = z.lazy(
  () => postApiMacroprojects200Schema,
);
